import * as THREE from "three";

export default function(
  color,
  scale,
  cardNumber,
  secondaryLight,
  camera,
  scene,
  container,
  vueBus
) {
  Object.setPrototypeOf(this, new THREE.PointLight(color));
  this.name = "MainLight";
  this.position.z = 40;

  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();
  const idCard = [];
  const velocityRatio = 20;
  let autoMove = 0.5;
  let clicked = true;
  let countActive = true;
  let cardFoundedNumber = 0;
  let xPosition = 0;
  let yPosition = 0;

  /*
   * @function - mouseMove
   * Sets xPosition and yPosition to make light follow cursor
   * @param - e: mousemove event argument
   */
  function mouseMove(e) {
    const reDefineX = e.pageX - window.innerWidth / 2;
    const reDefineY = e.pageY - window.innerHeight / 2;

    xPosition = (reDefineX * scale) / window.innerWidth;
    yPosition = -((reDefineY * scale) / window.innerHeight);
  }

  /*
   * @function - click
   * Performs action when card is clicked
   * @param - e: mousemove event argument
   */
  function click(e) {
    const cards = scene.children.filter(child => child.name === "Card");
    const cardInMovement = cards.filter(child => child.cardInMovement);
    const rect = container.getBoundingClientRect();

    mouse.x = ((e.clientX - rect.left) / container.clientWidth) * 2 - 1;
    mouse.y = -((e.clientY - rect.top) / container.clientHeight) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(scene.children);

    if (
      intersects.length > 0 &&
      ((intersects[0].object.type === "question" && clicked) ||
        (intersects[0].object.type === "answer" && !clicked))
    ) {
      if (cardInMovement.length) {
        if (intersects[0].object.cardInMovement) {
          clicked = intersects[0].object.type !== "question";
        }

        intersects[0].object.cardInMovement = false;
      } else {
        intersects[0].object.cardInMovement = true;

        if (intersects[0].object.type === "question") {
          idCard[0] = intersects[0].object.idValue;
        } else if (intersects[0].object.type === "answer") {
          idCard[1] = intersects[0].object.idValue;
          clicked = false;

          if (idCard[0] === idCard[1]) {
            cards.forEach(card => {
              if (card.idValue === idCard[0]) {
                card.name = "CardFounded";

                if (card.type === "answer") {
                  card.cardInMovement = false;
                  cardFoundedNumber++;
                  vueBus.$emit("Memoram: set game cards founded", cardFoundedNumber);

                  if (cardFoundedNumber === cardNumber) {
                    vueBus.$emit("Memoram: game finished");
                    countActive = false;
                  }

                  clicked = true;
                }
              }
            });
          }
        }
      }
    }
  }

  /*
   * @function - perform
   * Action of agents oriented programming 3d interfaces
   * @param - scene (ThreeJS Scene Instance): Scene instance of the 3d scene
   */
  function perform() {
    this.position.x = 2 * xPosition;
    this.position.y = 2 * yPosition;

    if (countActive) {
      if (!clicked && camera.position.x < scale * 3) {
        camera.position.x += scale / velocityRatio;
        this.position.z -= scale / velocityRatio;
        secondaryLight.position.z += scale / velocityRatio;
      } else if (clicked && camera.position.x > 0) {
        camera.position.x -= scale / velocityRatio;
        this.position.z += scale / velocityRatio;
        secondaryLight.position.z -= scale / velocityRatio;
      }
    } else {
      if (camera.position.x > scale * 3 + 2 * (scale / velocityRatio) || camera.position.x < 0) {
        autoMove = -autoMove;
      }

      camera.position.x += autoMove * (scale / velocityRatio);
      this.position.z -= autoMove * (scale / velocityRatio);
      secondaryLight.position.z += autoMove * (scale / velocityRatio);
    }
  }

  this.mouseMove = mouseMove;
  this.click = click;
  this.perform = perform;
}
